module.exports = __webpack_public_path__ + "static/media/image (17).dd964740.jpg";